#import "../../../../common/graphql/EntityDocumentsFields.graphql"
query AttachableUserProfileDocuments(
  $first: Int
  $after: Cursor
  $userProfileId: UUID
  $documentTypeId: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  attachableUserProfileDocuments(
    first: $first
    after: $after
    userProfileId: $userProfileId
    documentTypeId: $documentTypeId
    orderBy: $orderBy
    filter:$filter
  ) {
    nodes {
      ...EntityDocumentsFields
      _documentContents
      _isAccountingDocument
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
